// @ts-nocheck
import { selector } from "recoil";
import { companyDetailsState } from "./atom";

export const setcompanyDetails = selector<any>({
  key: "setcompanyDetails",
  get: () => null,
  set: ({ set }, companyDetails) => {
    set(companyDetailsState, companyDetails);
  },
});

export const getcompanyDetails = selector<any>({
  key: "getcompanyDetails",
  get: ({ get }) => {
    return get(companyDetailsState);
  },
});
